module.exports = __webpack_public_path__ + "img/FixedTime.57b24183.svg";